// Add storefront JS here if needed.

// This code Universally toggles SECTIONS starting with "product-info..."
function toggleProductInfoContent(sectionId) {
	var content = document.querySelector('.product-info-content_' + sectionId);
	var carat = document.querySelector('.product-info-carat_' + sectionId);
	if (content) content.classList.toggle('hidden');
	if (carat) carat.classList.toggle('rotate-180');
}

// This code toggles individual FAQ items in the usage-sector-body section.
// Each FAQ uses its own unique id (section.id + forloop.index) so they open
// and close independently.
function toggleFaqContent(faqId) {
	var content = document.querySelector('.faq-content_' + faqId);
	var carat = document.querySelector('.faq-carat_' + faqId);
	if (content) content.classList.toggle('hidden');
	if (carat) carat.classList.toggle('rotate-180');
}
